import onDownloadMultipleFilesToZip from 'utils/downloadMultipleFilesToZip'
import types from './types'
import { resource } from 'api'

/**
 * Display resources
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const displayResources = (isOpen, isLoading = false) => {
  return {
    type: types.DISPLAY_RESOURCES,
    isOpen,
    isLoading,
  }
}

/**
 * Update resources
 * @param {Array} [companyResources = []]
 */
const updateResources = (companyResources = []) => {
  return {
    type: types.UPDATE_RESOURCES,
    companyResources,
  }
}

/**
 * Update resources to download
 * @param {Array} [resourcesToDownload = []]
 */
const updateResourcesToDownload = (resourcesToDownload = []) => {
  return {
    type: types.SELECT_RESOURCES_TO_DOWNLOAD,
    resourcesToDownload,
  }
}

/**
 * Close collapse for resources plugin
 */
const close = () => async (dispatch) => {
  dispatch(displayResources(false))
}

/**
 * Get resources
 */
const get = ({ field, sort, search }) => async (dispatch) => {
  try {
    dispatch(displayResources(true, true))
    const res = await resource.pluginGetResources({ sortByField: field, sortType: sort, search })
    const { status, data } = res
    if (status === 200) {
      dispatch(updateResources(data))
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

const handleCheckResourcesToDownload = (item) => (dispatch, getStore) => {
  const { resources: { resourcesToDownload } } = getStore()
  const newResourcesToDownload = [...resourcesToDownload]
  const index = newResourcesToDownload.indexOf(item)
  if (index > -1) {
    newResourcesToDownload.splice(index, 1)
  } else {
    newResourcesToDownload.push(item)
  }
  dispatch(updateResourcesToDownload(newResourcesToDownload))
}

const handleDownloadMultipleResources = () => (dispatch, getStore) =>{
  const { resources: { resourcesToDownload } } = getStore()
  resourcesToDownload.forEach(url => {
    fetch(url).then(response => response.blob()).then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(blobUrl)
      document.body.removeChild(link)
    }).catch(error => console.error('Error al descargar archivo:', error))
  })
}

const handleDownloadMultipleResourcesAsZip =  () => async (dispatch, getStore) => {
  const { resources: { resourcesToDownload } } = getStore()
  onDownloadMultipleFilesToZip({ urls: resourcesToDownload, downLoadFileName: 'shared_resources.zip' })
}

export default {
  get,
  close,
  handleCheckResourcesToDownload,
  handleDownloadMultipleResources,
  handleDownloadMultipleResourcesAsZip,
}